/* istanbul ignore file */
import { generatePath } from '../utils'
import { getMpAgent } from './utils'

const mpAgent = getMpAgent()

const PATHS = {
  WORKFLOW: '/eqip-reference/workflow/:workflowId',
}
export type PracticePayment = {
  huRateAndUnit: string
  isPerUnit: boolean
  rateAndUnit: string
  wpRateAndUnit: string
  noRateAndUnit: string
  scenario: string
}

export type WorkflowPracticeDetails = {
  county: string
  state: string
  fipsCode: string
  practices: {
    payments: PracticePayment[]
    pdfUrl: string
    practiceCode: string
    practiceName: string
  }[]
}

export class EqipReferenceAPI {
  static getWorkflowPracticeDetails(
    workflowId: string,
    params: { selectedPractices?: string; useIntendedPractices?: boolean }
  ) {
    return mpAgent
      .get<WorkflowPracticeDetails>(generatePath(PATHS.WORKFLOW, { workflowId }), {
        params,
      })
      .then(response => {
        return response.data
      })
  }
}
